import React from 'react'
import { buttonClickEvent } from '../../utils/Analytics'
import { makeStyles } from '@material-ui/styles'
import {
    Alert,
    AlertTitle,
    AppBar,
    Button,
    Drawer,
    Grid,
    IconButton,
    Toolbar,
    Stack,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@material-ui/icons/CloseOutlined'

import { ColorPaper, ReportClauseButton } from '../Atoms'
import { FullDocument } from '../Molecules'
import { Word } from '../../utils'
import { goToFAQ } from '../../utils/UrlManipulation'

const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: theme.spacing(1),
    },
    toolbar: {
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        display: 'flex',
        height: 65,
    },
    alertBox: {
        width: '60vw',
        height: 75,
        cursor: 'pointer',
    },
    scrollContainer: {
        width: '60vw',
        overflowY: 'auto',
        overflowX: 'hidden',
        overflowScrolling: 'touch',
    }
}))

async function copyClause(clause) {
    try {
        await navigator.clipboard.writeText(clause.text.join(' '))
    } catch (err) {
        console.error('Failed to copy clause text: ', err);
    }
    buttonClickEvent("Copy clause text")
}

const Sidebar = ({ clause, onClose }) => {
    const { i18n, t } = useTranslation()
    const classes = useStyles()

    if (!clause) {
        return <Drawer
            key="sidebar"
            variant="temporary"
            anchor="right"
            open={false}
            onClose={onClose}
        />
    }

    const variant = clause.clause_id ? "clause" : "model"
    const may2019 = new Date("2019-05-01").getTime()
    const beforeMay2019 = new Date(clause.date).getTime() < may2019
    const enterpriseDeedType = (clause[`deed_type_${i18n.language}`] === 'Ondernemingen' ||
            clause[`deed_type_${i18n.language}`] === 'Entreprises')
    const showCompanyTypeWarning = beforeMay2019 && enterpriseDeedType

    return (
        <Drawer
            key="sidebar"
            variant="temporary"
            anchor="right"
            open={true}
            onClose={onClose}
        >
            <AppBar position="static">
                <Toolbar className={classes.toolbar}>
                    <Grid container alignItems="center">
                        <Grid container item xs={1}>
                            <IconButton
                                aria-label="close-details"
                                size="medium"
                                color="default"
                                onClick={onClose}
                            >
                                <CloseIcon style={{ color: 'white' }} />
                            </IconButton>
                        </Grid>
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={5} container justifyContent="flex-end">
                            {variant === "clause"
                                ? <ReportClauseButton clause={clause} />
                                : <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={() => Word.downloadWordFile(clause, i18n.language)}
                                    style={{ color: 'white', border: '1px solid white' }}>
                                    {t('sidebar.download')}
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <div className={classes.scrollContainer}>
                {variant === 'clause' &&
                <Stack spacing={0}>
                    <Alert severity="warning" onClick={goToFAQ} className={classes.alertBox}>
                        <AlertTitle>{t('sidebar.pseudoWarning.title')}</AlertTitle>
                        {t('sidebar.pseudoWarning.body')}
                    </Alert>
                    {showCompanyTypeWarning &&
                    <Alert severity="warning" className={classes.alertBox}>
                        <AlertTitle>{t('sidebar.companyTypeWarning.title')}</AlertTitle>
                        {t('sidebar.companyTypeWarning.body')}
                    </Alert>}
                </Stack>
                }
                <Grid container
                    spacing={1}
                    style={{ padding: '2rem' }}
                >
                    <ColorPaper style={{ marginTop: 25, marginBottom: 50 }}>
                        {variant === 'clause'
                            ? <FullDocument
                                originalClause={clause} />
                            : <div dangerouslySetInnerHTML={{ __html: clause.highlight.html_highlight || clause.html }} />
                        }
                    </ColorPaper>
                </Grid>
            </div>
            <Button
                variant="contained"
                size="medium"
                onClick={() => copyClause(clause)}
                style={{ width: "150px", marginLeft: "16px" }}
            >
                {t('sidebar.copyButton')}
            </Button>
        </Drawer >
    )
}

export default Sidebar
